// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1q6f4","row":"styles_row__DahOW"};